module.exports = __webpack_public_path__ + "media/sub2-9-1.913b5f44.mp4";